import { sliderClasses as a } from "@mui/material";
const r = {
  styleOverrides: {
    thumb: ({ theme: p }) => ({
      width: p.spacing(1.5),
      height: p.spacing(2.5),
      borderRadius: p.tokens.radius[4],
      backgroundColor: p.palette.background.level3,
      boxShadow: `
				0px 1px 3px 0px rgba(0, 0, 0, 0.10),
				0px 6px 6px 0px rgba(0, 0, 0, 0.09),
				0px 13px 8px 0px rgba(0, 0, 0, 0.05),
				0px 23px 9px 0px rgba(0, 0, 0, 0.01),
				0px 36px 10px 0px rgba(0, 0, 0, 0.00)
			`,
      [`&.${a.disabled}`]: {
        backgroundColor: p.palette.grey[400],
        boxShadow: "unset"
      }
    }),
    thumbSizeSmall: ({ theme: p }) => ({
      width: p.spacing(1),
      height: p.spacing(2),
      borderRadius: p.spacing(0.25)
    }),
    valueLabel: ({ theme: p }) => ({
      paddingLeft: p.spacing(1.5),
      paddingRight: p.spacing(1.5),
      color: p.palette.text.primary,
      backgroundColor: p.palette.background.level3,
      borderRadius: p.tokens.radius[4],
      boxShadow: `
				0px 3px 8px -1px rgba(0, 0, 0, 0.05),
				0px 5px 8px 0px rgba(0, 0, 0, 0.05),
				0px 1px 14px 0px rgba(0, 0, 0, 0.05)
			`,
      ...p.typography.body2
    })
  }
};
export {
  r as slider
};
//# sourceMappingURL=slider.mjs.map
